import { Injectable } from "@angular/core";
import { VngToastService } from "@vengreso/angular-components";

// Explicit bottom-center defaults (R7) — the library already defaults to
// bottom/center (vng-toast-container.component.ts), but pin it here so this
// wrapper's behavior doesn't silently change if the library default changes.
const DEFAULT_POSITION = {
  verticalPosition: "bottom" as const,
  horizontalPosition: "center" as const,
};

@Injectable()
export class NotificationService {

    constructor(private toastService: VngToastService) { }

    public toast(message: string, action: string = "OK", duration: number = 3000) {
        this.toastService.open(message, action, { duration, ...DEFAULT_POSITION });
    }

    public toastWithConfig(message: string, action: string = "OK", config: any) {
        this.toastService.open(message, action, { duration: 3000, ...DEFAULT_POSITION, ...config });
    }

    public toastWithoutAutoDismissal(message: string, action: string = "X") {
        this.toastService.open(message, action, { ...DEFAULT_POSITION });
    }
}
